import { render, staticRenderFns } from "./ConstructionDashboardDataComponent.vue?vue&type=template&id=3eccc888"
import script from "./ConstructionDashboardDataComponent.vue?vue&type=script&lang=js"
export * from "./ConstructionDashboardDataComponent.vue?vue&type=script&lang=js"
import style0 from "./ConstructionDashboardDataComponent.vue?vue&type=style&index=0&id=3eccc888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
